import { render, staticRenderFns } from "./wkModalForm.vue?vue&type=template&id=d4284dbc&scoped=true"
import script from "./wkModalForm.vue?vue&type=script&lang=js"
export * from "./wkModalForm.vue?vue&type=script&lang=js"
import style0 from "./wkModalForm.vue?vue&type=style&index=0&id=d4284dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4284dbc",
  null
  
)

export default component.exports